/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'plan-balanced-investing-48x48': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><circle pid="0" cx="24" cy="13.5" r="3"/><path pid="1" d="M24 1v8.75M31.5 47a7.5 7.5 0 00-15 0h15zM3 27a7.5 7.5 0 0015 0H3zM30 27a7.5 7.5 0 0015 0H30zM9 6h30.009M16.5 27l-6-21-6 21M43.5 27l-6-21-6 21M24 17.25v21.5"/></g>'
  }
})
